import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

// import assets
import './loadMore.scss';


class LoadMoreView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: this.props.isLoading,
      isDisabled: this.props.isDisabled,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick();
    this.setState({
      isLoading: true,
    });
  }

  render() {
    return (
      <div
        onClick={this.onClick}
        className={`m-load-more ${this.state.isLoading ? 'm-load-more--loading' : ''} ${this.state.isDisabled ? 'm-load-more--disabled' : ''}`}
        role={'button'}
        tabIndex={-1}
      >
        <div className={'m-load-more__bubbles'}>
          <div className={'m-load-more__bubble'} />
          <div className={'m-load-more__bubble'} />
          <div className={'m-load-more__bubble'} />
          <div className={'m-load-more__bubble'} />
        </div>
        {(() => {
          if (this.state.isDisabled && !this.state.isLoading) {
            return (<div className={'m-load-more__clickMore'}>{this.props.t('Click to load more')}</div>);
          }

          return null;
        })()}
      </div>
    );
  }
}

LoadMoreView.propTypes = {
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  t: PropTypes.func,
};
LoadMoreView.defaultProps = {
  isLoading: false,
  isDisabled: false,
  onClick: () => {
  },
  t: () => {
  },
};

export default translate()(LoadMoreView);



// WEBPACK FOOTER //
// ./frontend/js/Components/Util/LoadMore/LoadMoreView.jsx